/* eslint-disable react/destructuring-assignment */
import { t } from 'i18next';

import { ISROrganizationSubscriptionOverview } from '../../../../../../models/interfaces/Subscription/SecurityResponse/SROrganizationSubscriptionOverview';
import { FractionRenderer } from '../../../../../../styledComponents/MaterialTable/CellRenderers/CellRenderers';
import { overSubscribedSummaryRenderer } from '../../../../../../styledComponents/MaterialTable/CellRenderers/OverSubscribedSummaryRenderer/OverSubscribedSummaryRenderer';
import { Total } from './srSubscriptionOverviewPlansTable.styles';

export const getSummaryRow = (
  subscriptionOverview: ISROrganizationSubscriptionOverview,
  onSeeOversubscribedMembers?: () => void,
  permissions?: string[],
) => {
  if (!subscriptionOverview) {
    return null;
  }

  return {
    price: <Total>{`${t('phrase.total')}`}</Total>,
    membershipsInUse: (
      <FractionRenderer
        isSummary
        maxValue={subscriptionOverview.totalCapacity}
        value={subscriptionOverview.totalMembershipsInUse}
      />
    ),
    oversubscribed: overSubscribedSummaryRenderer(
      subscriptionOverview?.totalIsOversubscribed,
      onSeeOversubscribedMembers,
      permissions,
    ),
  };
};
